import React, { useState } from 'react';
import { useNavigate } from "react-router-dom";

import Logo from '../assets/images/PDever.png';
import Load from '../assets/images/loading-primary-bg.gif';

import { loginFunctionAndUpdateStatus } from '../config/loginConfig';

const Login2 = () => {
    const navigate = useNavigate();

    const [email, setEmail] = useState('');
    const [password, setPassword] = useState('');
    const [error, setError] = useState('');
    const [isLoading, setIsLoading] = useState(false);

    const handleLogin = async () => {
        setIsLoading(true);
        try {
            const check = await loginFunctionAndUpdateStatus(email, password);

            if (check === 'out') {
                setError('E-mail ou Mot de passe est incorrect !');
            } else if (check === 'online') {
                setError('Cet utilisateur est connecté sur un autre appareil !');
            } else if (check === 'in') {
                localStorage.setItem('isAuth', true);
                // console.log('isAuth :', localStorage.getItem('isAuth'));
                return navigate('/dashboard');
            } else if (check === 'access') {
                setError('Vous n\'avez pas accès pour vous connecter !');
            }

        } catch (error) {
            setError('Une erreur s\'est produite lors de la connexion');
        } finally {
            setIsLoading(false);
        }
    };

    const handleKeyPress = (e) => {
        if (e.key === "Enter") {
            handleLogin();
            setIsLoading(true);
        }
    };

    return (
        <div className='h-screen overflow-hidden flex justify-center items-center'>

            <div className='bg-white p-10 my-10 mx-auto w-full md:w-[40%] rounded-3xl'>

                <div className='w-full'>
                    <img src={Logo} alt="PDever logo" className='w-[100px] md:w-[120px] lg:w-[200px] mx-auto' />

                    <div className='mt-10'>
                        <p className='font-semibold mb-2'>E-mail</p>
                        <input
                            type="text"
                            className='w-full border border-gray rounded-md outline-none px-2 md:px-3 py-2 md:py-4'
                            placeholder='eg: email@gmail.com'
                            value={email}
                            onChange={(e) => setEmail(e.target.value)}
                            onKeyPress={handleKeyPress}
                            autoComplete="true"
                        />
                    </div>

                    <div className='mt-8'>
                        <p className='font-semibold mb-2'>Mot de passe</p>
                        <input
                            type="password"
                            className='w-full border border-gray rounded-md outline-none px-2 md:px-3 py-2 md:py-4'
                            placeholder='************'
                            value={password}
                            onChange={(e) => setPassword(e.target.value)}
                            onKeyPress={handleKeyPress}
                        />
                    </div>

                    <div className='w-full mt-5'>
                        <p className='text-center text-red font-semibold'>{error}</p>
                    </div>

                    <div className='mt-8 w-full flex justify-end'>
                        <button
                            className='font-semibold bg-primary w-[120px] lg:w-[190px] h-[50px] text-white rounded-md outline-none flex justify-center items-center'
                            onClick={() => handleLogin()}
                        >
                            {
                                isLoading ? (
                                    <img src={Load} alt='Loading ...' width={50} />
                                ) : (
                                    <p>Se connecter</p>
                                )
                            }
                        </button>
                    </div>
                </div>

            </div>

        </div >
    )
}

export default Login2